!function(){"use strict";const e="[data-newsletter-form]",t="[data-newsletter-heading]",s="has-success",o="has-error",i="hidden";customElements.get("newsletter-component")||customElements.define("newsletter-component",class extends HTMLElement{constructor(){super(),this.newsletter=this.querySelector(e),this.sessionStorage=window.sessionStorage,this.stopSubmit=!0,this.formID=null}connectedCallback(){"/challenge"!==window.location.pathname&&(this.newsletterSubmit=e=>this.newsletterSubmitEvent(e),this.newsletter.addEventListener("submit",this.newsletterSubmit),this.showMessage())}newsletterSubmitEvent(e){this.stopSubmit&&(e.preventDefault(),e.stopImmediatePropagation(),this.removeStorage(),this.writeStorage(),this.stopSubmit=!1,this.newsletter.submit())}writeStorage(){void 0!==this.sessionStorage&&this.sessionStorage.setItem("newsletter_form_id",this.newsletter.id)}readStorage(){this.formID=this.sessionStorage.getItem("newsletter_form_id")}removeStorage(){this.sessionStorage.removeItem("newsletter_form_id")}showMessage(){if(this.readStorage(),this.newsletter.id===this.formID){const e=document.getElementById(this.formID),n=e.parentElement.querySelector(t),r=-1!==window.location.search.indexOf("?customer_posted=true"),a=-1!==window.location.search.indexOf("accepts_marketing");r?(e.classList.remove(o),e.classList.add(s),n&&(n.classList.add(i),e.classList.remove(i))):a&&(e.classList.remove(s),e.classList.add(o),n&&(n.classList.add(i),e.classList.remove(i))),(r||a)&&window.addEventListener("load",(()=>{this.scrollToForm(e)})),
          (r || (!a && e.querySelector('.newsletter__message--success'))) && this.closePopupAfterSuccess(e)}}closePopupAfterSuccess(form) {
      // Keep the confirmed welcome code visible until the visitor closes it.
    }
    scrollToForm(e){const t=e.getBoundingClientRect();t.top>=0&&t.left>=0&&t.bottom<=window.theme.getWindowHeight()&&t.right<=window.theme.getWindowWidth()||setTimeout((()=>{window.theme.scrollTo(e.getBoundingClientRect().top)}),500)}})}();

// Remember confirmed subscriptions separately from closing the newsletter.
(() => {
  if (window.camilleNewsletterPersistence) return;
  window.camilleNewsletterPersistence = true;
  const key = 'camille-newsletter-subscribed-v1';
  const cookieName = 'camille_newsletter_subscribed';
  const remembered = () => {
    try { if (localStorage.getItem(key) === '1') return true; } catch (_) {}
    return document.cookie.split(';').some(value => value.trim() === cookieName + '=1');
  };
  const remember = () => {
    try { localStorage.setItem(key, '1'); } catch (_) {}
    document.cookie = cookieName + '=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
  };
  customElements.whenDefined('popup-newsletter').then(() => {
    const init = () => document.querySelectorAll('popup-newsletter').forEach(component => {
      if (component.dataset.subscriptionPersistence) return;
      component.dataset.subscriptionPersistence = 'true';
      const dialog = component.querySelector('dialog');
      if (!dialog) return;
      const wasSubscribed = remembered();
      const success = component.querySelector('.newsletter__message--success');
      let closedThisPage = false;
      let showConfirmation = Boolean(success && !wasSubscribed);
      if (success) {
        remember();
        if (!wasSubscribed && !window.Shopify?.designMode) {
          fetch('/discount/WELCOME10?redirect=%2Fcart', {credentials: 'same-origin'})
            .catch(() => { /* The displayed code remains available for manual entry. */ });
        }
        component.querySelectorAll('.input-group,.newsletter__fields,button[type="submit"],input[type="email"]').forEach(field => { field.hidden = true; field.style.display = 'none'; });
      }
      const originalOpen = component.popupOpen.bind(component);
      component.popupOpen = () => {
        if (dialog.open || closedThisPage || (remembered() && !showConfirmation && !window.Shopify?.designMode)) return;
        originalOpen();
      };
      // Closing is deliberately page-local; it must not pause invitations for days.
      component.cookie.read = () => false;
      component.cookie.write = () => {};
      dialog.addEventListener('theme:popup:onclose', () => { closedThisPage = true; });
      component.addEventListener('theme:popup:onclose', () => { closedThisPage = true; });
      const close = () => {
        showConfirmation = false;
        if (dialog.open) component.popupClose();
      };
      if (wasSubscribed && !window.Shopify?.designMode) {
        setTimeout(close, 600);
      } else if (success) {
        component.popupOpen();
      } else {
        component.showPopupEvents();
      }
      window.addEventListener('storage', event => { if (event.key === key && event.newValue === '1') close(); });
      window.addEventListener('pageshow', event => { if (event.persisted && remembered()) close(); });
    });
    init();
    document.addEventListener('shopify:section:load', init);
  });
})();
